import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ABOUT_SUPPORTS, ABOUT_PRINCIPLES, breadcrumbLd } from "@/lib/siteContent";

const crumbs = [{ label: "Home", to: "/" }, { label: "About Us", to: "/about-us" }];

export default function AboutUs() {
  return (
    <div className="ca-container py-12 max-w-3xl">
      <Seo title="About ComplaintAdvisor | Complaint Documentation and Resolution Support"
        description="Learn about ComplaintAdvisor's mission to support clearer complaint documentation, customer-vendor communication, transparency, and access to official help."
        path="/about-us" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3">About ComplaintAdvisor</h1>
      <p className="text-slate-700 mt-3 leading-relaxed">
        ComplaintAdvisor was created to make customer and vendor disputes easier to document, understand, and communicate about.
      </p>

      <h2 className="font-display text-lg font-bold text-slate-900 mt-8">What the platform supports</h2>
      <ul className="mt-3 grid sm:grid-cols-2 gap-2">
        {ABOUT_SUPPORTS.map((s) => (
          <li key={s} className="rounded-xl border border-slate-200 bg-white p-3 text-sm text-slate-700 flex items-center gap-2">
            <ShieldCheck className="h-4 w-4 text-teal shrink-0" /> {s}
          </li>
        ))}
      </ul>

      <h2 className="font-display text-lg font-bold text-slate-900 mt-8">Our principles</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {ABOUT_PRINCIPLES.map((p) => <span key={p} className="rounded-full bg-teal-brand/10 text-teal px-3 py-1 text-sm font-medium">{p}</span>)}
      </div>

      <div className="mt-8 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm text-slate-600">
        ComplaintAdvisor does not decide legal liability and does not guarantee a particular dispute outcome. It is not a court,
        government authority, police service, debt collection agency, law firm, or arbitrator.
      </div>

      <p className="mt-6 text-sm text-slate-500">
        Explore <Link to="/check-before-you-trust" className="text-teal">how to check before you trust</Link>,{" "}
        <Link to="/file-a-complaint" className="text-teal">file a structured complaint</Link>, or{" "}
        <Link to="/government-help" className="text-teal">find official complaint channels</Link>.
      </p>
    </div>
  );
}
